/* eslint-disable max-len */
import React, {useState} from 'react'
import {connect} from 'react-redux'

import {Icon, Modal2 as Modal} from '@lazarusai/forms-ui-components'

import stylesResponseHistory from '../styles/ResponseHistory.module.css'

function ResponseHistory(props) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <div
        onClick={() => setIsModalOpen(!isModalOpen)}
        className={`${stylesResponseHistory['response-history-icon-wrapper']}`}
        title={'Response History'}
      >
        <Icon
          icon={'clock-outline'}
        />
      </div>
      <Modal
        isVisible={isModalOpen}
        onDismiss={() => {
          setIsModalOpen(false)
        }}
        title={'Response History'}
        theme={props.theme}
      >
        <div
          className={`${stylesResponseHistory['response-history-body']}`}
        >
          {(props?.messageHistory || []).toReversed().map((messages, i) => {
            return (
              <p key={`messages-${i}`}>
                {JSON.stringify(messages, null, 2)}
              </p>
            )
          })}
        </div>
      </Modal>
    </>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  messageHistory: state.userReducer.messageHistory,
})

export default connect(
    mapStateToProps,
    {},
)(ResponseHistory)
